import React, { useState } from "react";
import { Link } from "react-router-dom";
import clsx from "clsx";
import useStyles from "./styles";
import SpecificSportsFooter from "../SportsPages/SpecificSportsFooter";

export default function DeskFooter() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen((prev) => !prev);
  };
  const classes = useStyles();

  return (
    <>
      <div>
        <div className={classes.whiteArea}>
          <div>
            <div>
              <h2 className={clsx(classes.textTop)}>
                Top Sports Venues in Cities
              </h2>
            </div>
            <section>
              <div className={clsx(classes.textBox)}>
                <h2 className={clsx(classes.textBoxHead)}>Bengaluru</h2>
                <hr className={clsx(classes.cityBorder)}></hr>
                <p className={clsx(classes.textBoxPara)}>
                  <a
                    href="https://www.khelomore.com/sports-venues/bengaluru/sports/all"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Sports Venues in Bengaluru
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/bengaluru/sports/pickleball"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Pickleball Courts in Bengaluru
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/bengaluru/sports/badminton"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Badminton Courts in Bengaluru
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/bengaluru/sports/football"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Football Turfs in Bengaluru
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/bengaluru/sports/box_cricket"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Box Cricket Turfs in Bengaluru
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/bengaluru/sports/cricket"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Cricket Grounds in Bengaluru
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/bengaluru/sports/tennis"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Tennis Courts in Bengaluru
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/bengaluru/sports/basketball"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Basketball Court in Bengaluru
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/bengaluru/sports/swimming"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Swimming Pools in Bengaluru
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/bengaluru/sports/table_tennis"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Table Tennis Clubs in Bengaluru
                  </a>
                </p>
              </div>
              <div className={clsx(classes.textBox)}>
                <h2 className={clsx(classes.textBoxHead)}>Mumbai</h2>
                <hr className={clsx(classes.cityBorder)}></hr>
                <p className={clsx(classes.textBoxPara)}>
                  <a
                    href="https://www.khelomore.com/sports-venues/mumbai/sports/all"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Sports Venues in Mumbai
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/mumbai/sports/pickleball"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Pickleball Courts in Mumbai
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/mumbai/sports/badminton"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Badminton Courts in Mumbai
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/mumbai/sports/football"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Football Turfs in Mumbai
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/mumbai/sports/box_cricket"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Box Cricket Turfs in Mumbai
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/mumbai/sports/cricket"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Cricket Grounds in Mumbai
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/mumbai/sports/tennis"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Tennis Courts in Mumbai
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/mumbai/sports/basketball"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Basketball Court in Mumbai
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/mumbai/sports/swimming"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Swimming Pools in Mumbai
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/mumbai/sports/table_tennis"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Table Tennis Clubs in Mumbai
                  </a>
                </p>
              </div>
              <div className={clsx(classes.textBox)}>
                <h2 className={clsx(classes.textBoxHead)}>Delhi & NCR</h2>
                <hr className={clsx(classes.cityBorder)}></hr>
                <p className={clsx(classes.textBoxPara)}>
                  <a
                    href="https://www.khelomore.com/sports-venues/delhi-&-ncr/sports/all"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Sports Venues in Delhi & NCR
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/delhi-&-ncr/sports/pickleball"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Pickleball Courts in Delhi & NCR
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/delhi-&-ncr/sports/badminton"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Badminton Courts in Delhi & NCR
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/delhi-&-ncr/sports/football"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Football Turfs in Delhi & NCR
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/delhi-&-ncr/sports/box_cricket"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Box Cricket Turfs in Delhi & NCR
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/delhi-&-ncr/sports/cricket"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Cricket Grounds in Delhi & NCR
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/delhi-&-ncr/sports/tennis"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Tennis Courts in Delhi & NCR
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/delhi-&-ncr/sports/basketball"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Basketball Court in Delhi & NCR
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/delhi-&-ncr/sports/table_tennis"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Table Tennis Clubs in Delhi & NCR
                  </a>
                </p>
              </div>
              <div className={clsx(classes.textBox)}>
                <h2 className={clsx(classes.textBoxHead)}>Hyderabad</h2>
                <hr className={clsx(classes.cityBorder)}></hr>
                <p className={clsx(classes.textBoxPara)}>
                  <a
                    href="https://www.khelomore.com/sports-venues/hyderabad/sports/all"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Sports Venues in Hyderabad
                  </a>
                  &nbsp;|&nbsp;
                  {/* <Link to="/pickleball-courts-in-hyderabad">
                    Pickleball Courts in Hyderabad
                  </Link> */}
                  <a
                    href="https://www.khelomore.com/sports-venues/hyderabad/sports/pickleball"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Pickleball Courts in Hyderabad
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/hyderabad/sports/badminton"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Badminton Courts in Hyderabad
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/hyderabad/sports/football"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Football Turfs in Hyderabad
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/hyderabad/sports/box_cricket"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Box Cricket Turfs in Hyderabad
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/hyderabad/sports/cricket"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Cricket Grounds in Hyderabad
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/hyderabad/sports/tennis"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Tennis Courts in Hyderabad
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/hyderabad/sports/basketball"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Basketball Court in Hyderabad
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/hyderabad/sports/swimming"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Swimming Pools in Hyderabad
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/hyderabad/sports/table_tennis"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Table Tennis Clubs in Hyderabad
                  </a>
                </p>
              </div>
              <div className={clsx(classes.textBox)}>
                <h2 className={clsx(classes.textBoxHead)}>Pune</h2>
                <hr className={clsx(classes.cityBorder)}></hr>
                <p className={clsx(classes.textBoxPara)}>
                  <a
                    href="https://www.khelomore.com/sports-venues/pune/sports/all"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Sports Venues in Pune
                  </a>
                  &nbsp;|&nbsp;
                  {/* <SpecificSportsFooter /> */}
                  {/* <Link to="/pickleball-courts-in-pune">
                    Pickleball Courts in Pune
                  </Link> */}
                  <a
                    href="https://www.khelomore.com/sports-venues/pune/sports/pickleball"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Pickleball Courts in Pune
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/pune/sports/badminton"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Badminton Courts in Pune
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/pune/sports/football"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Football Turfs in Pune
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/pune/sports/box_cricket"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Box Cricket Turfs in Pune
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/pune/sports/cricket"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Cricket Grounds in Pune
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/pune/sports/tennis"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Tennis Courts in Pune
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/pune/sports/basketball"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Basketball Court in Pune
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/pune/sports/swimming"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Swimming Pools in Pune
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/pune/sports/table_tennis"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Table Tennis Clubs in Pune
                  </a>
                </p>
              </div>
              <div className={clsx(classes.textBox)}>
                <h2 className={clsx(classes.textBoxHead)}>Nagpur</h2>
                <hr className={clsx(classes.cityBorder)}></hr>
                <p className={clsx(classes.textBoxPara)}>
                  <a
                    href="https://www.khelomore.com/sports-venues/nagpur/sports/all"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Sports Venues in Nagpur
                  </a>
                  &nbsp;|&nbsp;
                  {/* <Link to="/pickleball-courts-in-nagpur">
                    Pickleball Courts in Nagpur
                  </Link> */}
                  <a
                    href="https://www.khelomore.com/sports-venues/nagpur/sports/pickleball"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Pickleball Courts in Nagpur
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/nagpur/sports/badminton"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Badminton Courts in Nagpur
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/nagpur/sports/football"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Football Turfs in Nagpur
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/nagpur/sports/box_cricket"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Box Cricket Turfs in Nagpur
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/nagpur/sports/cricket"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Cricket Grounds in Nagpur
                  </a>
                </p>
              </div>
              <div className={clsx(classes.textBox)}>
                <h2 className={clsx(classes.textBoxHead)}>Surat</h2>
                <hr className={clsx(classes.cityBorder)}></hr>
                <p className={clsx(classes.textBoxPara)}>
                  <a
                    href="https://www.khelomore.com/sports-venues/surat/sports/all"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Sports Venues in Surat
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/surat/sports/pickleball"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Pickleball Courts in Surat
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/surat/sports/badminton"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Badminton Courts in Surat
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/surat/sports/football"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Football Turfs in Surat
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/surat/sports/box_cricket"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Box Cricket Turfs in Surat
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/surat/sports/cricket"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Cricket Grounds in Surat
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/surat/sports/table_tennis"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Table Tennis Clubs in Surat
                  </a>
                </p>
              </div>
              <div className={clsx(classes.textBox)}>
                <h2 className={clsx(classes.textBoxHead)}>Ahmedabad</h2>
                <hr className={clsx(classes.cityBorder)}></hr>
                <p className={clsx(classes.textBoxPara)}>
                  <a
                    href="https://www.khelomore.com/sports-venues/ahmedabad/sports/all"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Sports Venues in Ahmedabad
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/ahmedabad/sports/pickleball"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Pickleball Courts in Ahmedabad
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/ahmedabad/sports/football"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Football Turfs in Ahmedabad
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/ahmedabad/sports/box_cricket"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Box Cricket Turfs in Ahmedabad
                  </a>
                  &nbsp;|&nbsp;
                  <a
                    href="https://www.khelomore.com/sports-venues/ahmedabad/sports/tennis"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Tennis Courts in Ahmedabad
                  </a>
                </p>
              </div>
            </section>
          </div>

          {/* City venue accordion */}

          {/* <div
            className={clsx(
              classes.flex,
              classes.spaceBw,
              classes.alignBase,
              classes.pointer
            )}
            onClick={toggleAccordion}
          >
            <h2 className={clsx(classes.textTop)}>
              Top Sports Venues in Cities
            </h2>
            <div>
              <img
                style={{
                  display: "inline-block",
                  transition: "transform 0.3s ease",
                  transform: isOpen ? "rotate(-90deg)" : "rotate(0deg)",
                }}
                src={downArrow}
                alt="down arrow"
              />
            </div>
          </div>
          <section
            style={{
              maxHeight: isOpen ? "max-content" : "0",
              overflow: "hidden",
              transition: "max-height 0.3s ease",
              background: "#fff",
              padding: isOpen ? "12px 16px" : "0 16px",
            }}
          >
            <div className={clsx(classes.textBox)}>
              <h2 className={clsx(classes.textBoxHead)}>Bengaluru</h2>
              <hr className={clsx(classes.cityBorder)}></hr>
              <p className={clsx(classes.textBoxPara)}>
                <a
                  href="https://www.khelomore.com/sports-venues/bengaluru/planet-sports-whitefield/617"
                  target="_blank"
                >
                  Planet Sports
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/bengaluru/rush-arena-cooke-town-maruthi-sevanagar/2002"
                  target="_blank"
                >
                  Rush Arena - Cooke Town
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/bengaluru/sun-play-arena-kengeri-satellite-town/426"
                  target="_blank"
                >
                  Sun Play Arena
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/bengaluru/kbm-sports-arena-kadugodi-post/1713"
                  target="_blank"
                >
                  KBM Sports Arena
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/bengaluru/rush-arena-x-khelomore-gt-mall-vijayanagar/1146"
                  target="_blank"
                >
                  Rush Arena X KheloMore GT Mall
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/bengaluru/pickle-point-rt-nagar/2047"
                  target="_blank"
                >
                  Pickle Point
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/bengaluru/karnataka-state-pickleball-association-(kspa)-pay-n-play-nagarbhavi/2011"
                  target="_blank"
                >
                  Karnataka State Pickleball Association (KSPA) Pay n Play
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/bengaluru/pykln-sports-hsr-layout-hsr-layout/2102"
                  target="_blank"
                >
                  PYKLN Sports - HSR Layout
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/bengaluru/rush-arena-rajajinagar-rajajinagar/89"
                  target="_blank"
                >
                  Rush Arena - Rajajinagar
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/bengaluru/isro-match-point-banashankari/921"
                  target="_blank"
                >
                  ISRO Match Point
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/bengaluru/machaxi-jc-sports-bellandur/2044"
                  target="_blank"
                >
                  Machaxi JC Sports
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/bengaluru/4s-shuttle-smash-sports-studio-amalodbhavi-nagar/288"
                  target="_blank"
                >
                  4S Shuttle Smash Sports Studio
                </a>
              </p>
            </div>
            <div className={clsx(classes.textBox)}>
              <h2 className={clsx(classes.textBoxHead)}>Mumbai</h2>
              <hr className={clsx(classes.cityBorder)}></hr>
              <p className={clsx(classes.textBoxPara)}>
                <a
                  href="https://www.khelomore.com/sports-venues/navi-mumbai/nerul-gymkhana-nerul/2056"
                  target="_blank"
                >
                  Nerul Gymkhana
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/mumbai/district-sports-club-bandra-kurla-complex/191"
                  target="_blank"
                >
                  District Sports Club
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/mumbai/urban-sports-gtc-padel-and-pickleball-vile-parle-vile-parle-west/2160"
                  target="_blank"
                >
                  Urban Sports GTC Padel and Pickleball Vile Parle
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/mumbai/ptks-vile-parle-east/1840"
                  target="_blank"
                >
                  PTKS
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/mumbai/urban-sports-zone-hindu-gymkhana-marine-lines/211"
                  target="_blank"
                >
                  Urban Sports Zone Hindu Gymkhana
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/mumbai/maharashtra-state-lawn-tennis-association-cooperage/603"
                  target="_blank"
                >
                  Maharashtra State Lawn Tennis Association
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/mumbai/eagle-vision-sports-and-fitness-academy-borivali-west/1827"
                  target="_blank"
                >
                  Eagle Vision Sports and fitness academy
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/mumbai/urban-sports-zone-dr-antonio-da-silva-high-school-dadar-west/169"
                  target="_blank"
                >
                  Urban Sports Zone - Dr Antonio Da Silva High School
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/mumbai/chhedanagar-gymkhana-by-israd-sports-chembur-west/2191"
                  target="_blank"
                >
                  Chhedanagar Gymkhana by ISRAD Sports
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/mumbai/aita-tennis-center-of-excellence-santacruz-east/1752"
                  target="_blank"
                >
                  AITA Tennis Center of Excellence
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/navi-mumbai/indo-sports-academy-(badminton)-kamothe/1544"
                  target="_blank"
                >
                  Indo Sports Academy (Badminton)
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/mumbai/players-turf-mahakali-caves-andheri-east/641"
                  target="_blank"
                >
                  Players Turf Mahakali Caves
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/mumbai/urban-padel-vile-parle-(w)/1961"
                  target="_blank"
                >
                  Urban Padel
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/mumbai/urban-sports-zone-janki-devi,-andheri-andheri-west/174"
                  target="_blank"
                >
                  Urban Sports Zone - Janki Devi, Andheri
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/thane/urban-sports-thane-goenka-thane-west/189"
                  target="_blank"
                >
                  Urban Sports - Thane Goenka
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/thane/mark10-pickleball-academy-thane-west/1999"
                  target="_blank"
                >
                  Mark10 Pickleball Academy
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/thane/urban-sports-thane-upvan-thane-west/2"
                  target="_blank"
                >
                  Urban Sports Thane Upvan
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/thane/finland-international-school-thane-wagle-estate/925"
                  target="_blank"
                >
                  Finland International School - Thane
                </a>
              </p>
            </div>
            <div className={clsx(classes.textBox)}>
              <h2 className={clsx(classes.textBoxHead)}>Delhi</h2>
              <hr className={clsx(classes.cityBorder)}></hr>
              <p className={clsx(classes.textBoxPara)}>
                <a
                  href="https://www.khelomore.com/sports-venues/delhi/player's-den-shalimar-bagh-shalimar-bagh/203"
                  target="_blank"
                >
                  Player's Den - Shalimar Bagh
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/delhi/player's-den-punjabi-bagh-west-punjabi-bagh/2204"
                  target="_blank"
                >
                  Player's Den Punjabi Bagh
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/delhi/playplex-pickleball-%7C-dips-rohini-rohini/2281"
                  target="_blank"
                >
                  PlayPlex Pickleball | DIPS Rohini
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/new-delhi/player-s-den-tirang-pickleball-and-box-cricket-arena-rajapur/1963"
                  target="_blank"
                >
                  Player s Den Tirang Pickleball and Box Cricket Arena
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/new-delhi/av-x-khelomore-pickleball-academy-pitampura/2034"
                  target="_blank"
                >
                  AV X KheloMore Pickleball Academy
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/new-delhi/tirang-badminton-centre-%7C-goyla-vihar-goyla-vihar/1395"
                  target="_blank"
                >
                  Tirang Badminton Centre | Goyla Vihar
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/noida/playall-sports-complex-@-sector-73-noida-sector-73/140"
                  target="_blank"
                >
                  PlayAll Sports Complex @ Sector 73 Noida
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/noida/playall-sports-complex-@-gaur-city-1,-greater-noida-noida/1588"
                  target="_blank"
                >
                  PlayAll Sports Complex @ Gaur City 1, Greater Noida
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/noida/playall-sports-complex-@-modern-school-noida-sector-11-noida/1580"
                  target="_blank"
                >
                  PlayAll Sports Complex @ Modern School Noida Sector 11
                </a>
              </p>
            </div>
            <div className={clsx(classes.textBox)}>
              <h2 className={clsx(classes.textBoxHead)}>Hyderabad</h2>
              <hr className={clsx(classes.cityBorder)}></hr>
              <p className={clsx(classes.textBoxPara)}>
                <a
                  href="https://www.khelomore.com/sports-venues/hyderabad/speed-badminton-academy-kothapet/278"
                  target="_blank"
                >
                  Speed Badminton Academy
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/hyderabad/friends-badminton-academy-sri-aurobindo-colony/277"
                  target="_blank"
                >
                  Friends Badminton Academy
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/hyderabad/olympus-badminton-academy-ragala-enclave/303"
                  target="_blank"
                >
                  Olympus Badminton academy
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/hyderabad/lepaksh-badminton-court-rock-town-residents-colony/322"
                  target="_blank"
                >
                  Lepaksh Badminton Court
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/hyderabad/rapidacez-badminton-&-fitness-academy(-kaynes-badminton-academy)-golden-heights-colony/314"
                  target="_blank"
                >
                  Rapidacez badminton & fitness academy( kaynes badminton
                  academy)
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/hyderabad/r3-badminton-excellencia-kothapet/709"
                  target="_blank"
                >
                  R3 Badminton Excellencia
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/hyderabad/sk-badminton-academy-arunodaya-nagar/1488"
                  target="_blank"
                >
                  SK Badminton academy
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/hyderabad/hit-zone-box-cricket-uppal/987"
                  target="_blank"
                >
                  Hit Zone Box Cricket
                </a>
              </p>
            </div>
            <div className={clsx(classes.textBox)}>
              <h2 className={clsx(classes.textBoxHead)}>Pune</h2>
              <hr className={clsx(classes.cityBorder)}></hr>
              <p className={clsx(classes.textBoxPara)}>
                <a
                  href="https://www.khelomore.com/sports-venues/pune/reboot-sports-arena-hinjewadi/1614"
                  target="_blank"
                >
                  Reboot Sports Arena
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/pune/pacific-sports-arena-hinjewadi/512"
                  target="_blank"
                >
                  Pacific Sports Arena
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/pune/area51-sports-arena-hinjewadi/1917"
                  target="_blank"
                >
                  Area51 Sports Arena
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/pune/poona-gymkhana-hinjewadi/1664"
                  target="_blank"
                >
                  Poona Gymkhana
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/pune/aliens-badminton-school-ravet/1585"
                  target="_blank"
                >
                  Aliens Badminton School
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/pune/gravity-badminton-complex-@-dange-chowk-pimpri-chinchwad/955"
                  target="_blank"
                >
                  Gravity Badminton Complex @ Dange Chowk
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/pune/royal-shuttlers-arenaa-(rsa)-hinjewadi/2023"
                  target="_blank"
                >
                  Royal Shuttlers Arenaa (RSA)
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/pune/shivchhatrapati-sports-complex-pay-and-play-balewadi/1044"
                  target="_blank"
                >
                  Shivchhatrapati Sports Complex - Pay and Play
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/pune/ace-arena-chinchwad-chinchwad/2024"
                  target="_blank"
                >
                  Ace Arena Chinchwad
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/pune/lenoah-sportsplex-hinjewadi/1785"
                  target="_blank"
                >
                  LeNoah Sportsplex
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/pune/leap-academy-pimplesaudagar/1743"
                  target="_blank"
                >
                  LEAP Academy
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/pune/pdmba-sports-complex-behind-modern-high-school/498"
                  target="_blank"
                >
                  PDMBA Sports Complex
                </a>
              </p>
            </div>
            <div className={clsx(classes.textBox)}>
              <h2 className={clsx(classes.textBoxHead)}>Surat</h2>
              <hr className={clsx(classes.cityBorder)}></hr>
              <p className={clsx(classes.textBoxPara)}>
                <a
                  href="https://www.khelomore.com/sports-venues/surat/pickleup-de-villa-hazira-rd,-bhatha/1998"
                  target="_blank"
                >
                  Pickleup De Villa
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/surat/pickle-dynasty-behind-star-galaxy/2213"
                  target="_blank"
                >
                  Pickle Dynasty
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/surat/pickle-fusion-in-the-lane-of-1819-cafe/2043"
                  target="_blank"
                >
                  Pickle Fusion
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/surat/pickleup-indoor-courts-vesu/1937"
                  target="_blank"
                >
                  PickleUP Indoor Courts
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/surat/surat-pickleball-club-opposite-science-center/2133"
                  target="_blank"
                >
                  Surat Pickleball Club
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/surat/rg-pickle-spot-vesu/2086"
                  target="_blank"
                >
                  RG Pickle Spot
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/surat/khelmanthan-pickleball-arena-parvat-patiya/2082"
                  target="_blank"
                >
                  Khelmanthan Pickleball Arena
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/surat/hoa-pickle-point-katargam/2118"
                  target="_blank"
                >
                  HOA Pickle Point
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/surat/d99-indoor-pickleball-court-ghod-dod-road/2135"
                  target="_blank"
                >
                  D99 Indoor Pickleball Court
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/surat/smashup-turf-surat-vesu/1267"
                  target="_blank"
                >
                  Smashup Turf Surat
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/surat/pickleton-bhimrad-althan-road/2273"
                  target="_blank"
                >
                  PICKLETON
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/surat/kinaara-the-sports-cafe-k2-vesu/606"
                  target="_blank"
                >
                  Kinaara The Sports Cafe K2
                </a>
              </p>
            </div>
            <div className={clsx(classes.textBox)}>
              <h2 className={clsx(classes.textBoxHead)}>Vadodara</h2>
              <hr className={clsx(classes.cityBorder)}></hr>
              <p className={clsx(classes.textBoxPara)}>
                <a
                  href="https://www.khelomore.com/sports-venues/vadodara/united-sports-arena-manjalpur/1874"
                  target="_blank"
                >
                  United Sports Arena
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/vadodara/baroda-sports-arena-bhayli-sevasi-ring-road/2019"
                  target="_blank"
                >
                  Baroda Sports Arena
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/vadodara/vadodara-cricket-academy-bhayli/1627"
                  target="_blank"
                >
                  Vadodara Cricket Academy
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/vadodara/77-sports-arena-bhayli/2175"
                  target="_blank"
                >
                  77 Sports Arena
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/vadodara/dink-it-by-bsa-bhayli-sevasi-ring-road/2098"
                  target="_blank"
                >
                  Dink It by BSA
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/vadodara/3rd-shot-by-strokes-khanpur/2060"
                  target="_blank"
                >
                  3rd Shot by Strokes
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/vadodara/sky-sports-zone-waghodiya-chokdi/2198"
                  target="_blank"
                >
                  Sky Sports Zone
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/vadodara/elevate-sports-khanpur/1859"
                  target="_blank"
                >
                  Elevate Sports
                </a>
              </p>
            </div>
            <div className={clsx(classes.textBox)}>
              <h2 className={clsx(classes.textBoxHead)}>Nagpur</h2>
              <hr className={clsx(classes.cityBorder)}></hr>
              <p className={clsx(classes.textBoxPara)}>
                <a
                  href="https://www.khelomore.com/sports-venues/nagpur/smash-point-sitabuldi/2013"
                  target="_blank"
                >
                  Smash Point
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.khelomore.com/sports-venues/nagpur/the-pickle-club-pardi/2224"
                  target="_blank"
                >
                  The Pickle Club
                </a>
              </p>
            </div>
          </section> */}
        </div>
        <div className={clsx(classes.footerContainer)}>
          {/* <hr className={clsx(classes.hrFooter)}></hr> */}
          {/* <div className={clsx(classes.flex,classes.footerCardsContainer,classes.spaceBw)}>
                    <div className={clsx(classes.footerCard, classes.flex,classes.alignCenter)}>
                        <a href="https://khelomore.com/sports-venues"> <img className={clsx(classes.footerCardIcon)} src={cardIcon_One} alt="icon" /></a>
                        <div className={clsx(classes.footerCardTextBox)}>
                            <a href="https://khelomore.com/sports-venues">
                                <h6 className={clsx(classes.footerCardHead)}>Book Sports Venues</h6>
                                <p className={clsx(classes.footerCardText)}>Choose from 1000+ sports venues</p>
                            </a>
                           
                        </div>
                    </div>
                    <div className={clsx(classes.footerCard, classes.flex,classes.alignCenter)}>
                        <a href="https://khelomore.com/sports-coaching/?category=at_home"> <img className={clsx(classes.footerCardIcon)} src={cardIcon_Two} alt="icon" /></a>
                        <div className={clsx(classes.footerCardTextBox)}>
                            <a href="https://khelomore.com/sports-coaching/?category=at_home">
                                <h6 className={clsx(classes.footerCardHead)}>Find a Coach Near You</h6>
                                <p className={clsx(classes.footerCardText)}>Get trained by coaches at home</p>
                            </a>
                        </div>
                    </div>
                    <div className={clsx(classes.footerCard, classes.flex,classes.footerCardMZero,classes.alignCenter)}>
                        <a href="https://shop.khelomore.com/"> <img className={clsx(classes.footerCardIcon)} src={cardIcon_Three} alt="icon" /></a>
                        <div className={clsx(classes.footerCardTextBox)}>
                            <a href="https://shop.khelomore.com/">
                                <h6 className={clsx(classes.footerCardHead)}>KM Shop</h6>
                                <p className={clsx(classes.footerCardText)}>Get sport essentials at best prices</p>
                            </a>  
                        </div>
                    </div>
                    <div className={clsx(classes.footerCard, classes.flex,classes.footerCardMZero,classes.alignCenter)}>
                        <a href="https://docs.google.com/forms/d/e/1FAIpQLSeHRjh5iIz-zS-iCeB1S8kPuosccr6MWV0ByZx4IAJ3nCfOVg/viewform"> <img className={clsx(classes.footerCardIcon)} src={cardIcon_Four} alt="icon" /></a>
                        <div className={clsx(classes.footerCardTextBox)}>
                          <a href="https://docs.google.com/forms/d/e/1FAIpQLSeHRjh5iIz-zS-iCeB1S8kPuosccr6MWV0ByZx4IAJ3nCfOVg/viewform">
                            <h6 className={clsx(classes.footerCardHead)}>Register your Venue</h6>
                            <p className={clsx(classes.footerCardText)}>Get access to 1M+ users</p>
                          </a>                           
                        </div>
                    </div>
                </div>
                <hr className={clsx(classes.hrFooter)}></hr> */}
          <div
            className={clsx(classes.flex, classes.consumers, classes.spaceBw)}
          >
            <div
              className={clsx(
                classes.flex,
                classes.flex30,
                classes.spcaeEvenly,
                classes.borderRight
              )}
            >
              {/* <div className={clsx(classes.consumersCard)}>
                            <h3 className={clsx(classes.consumersHead)}>Categories</h3>
                            <span className={clsx(classes.consumersText)}>Sports Equipment</span>
                            <span className={clsx(classes.consumersText)}>Active Wear & Shoes</span>
                            <span className={clsx(classes.consumersText)}>Accessories & Essentials</span>
                            <span className={clsx(classes.consumersText)}>Food & Beverages</span>
                          </div> 
                          <div className={clsx(classes.consumersCard)}>
                              <h3 className={clsx(classes.consumersHead)}>For Consumers</h3>
                              <span className={clsx(classes.consumersText)}>Privacy Policy</span>
                              <Link to="/terms-conditions" className={clsx(classes.consumersText)}>Terms and Conditons</Link>
                              <Link to="/about-us" className={clsx(classes.consumersText)}>About Khelomore</Link>
                              <span className={clsx(classes.consumersText)}>FAQs</span>
                              <span className={clsx(classes.consumersText)}>Ask about Security</span>
                          </div> 
                          <div className={clsx(classes.consumersCard,classes.flex,classes.flexCol,classes.justifyCenter)}>
                              <span className={clsx(classes.consumersTextEnd)}>Raise a Request</span>
                              <span className={clsx(classes.consumersTextEnd)}>My Bookings</span>
                              <span className={clsx(classes.consumersTextEnd)}>Track Order</span>
                          </div> */}
              <div className={clsx(classes.consumersCard)}>
                <h3 className={clsx(classes.consumersHead)}>For Consumers</h3>
                <Link
                  to="/privacy-policy"
                  className={clsx(classes.consumersText)}
                >
                  Privacy Policy
                </Link>
                <Link
                  to="/terms-conditions"
                  className={clsx(classes.consumersText)}
                >
                  Terms & Conditons
                </Link>
                <Link to="/faq" className={clsx(classes.consumersText)}>
                  FAQs
                </Link>
                <Link to="/about-us" className={clsx(classes.consumersText)}>
                  About Khelomore
                </Link>
                <Link to="/careers" className={clsx(classes.consumersText)}>
                  Careers
                </Link>
                <Link
                  to="/partnerships"
                  className={clsx(classes.consumersText)}
                >
                  Partnerships
                </Link>
              </div>
              {/* <div className={clsx(classes.consumersCard)}>
                <h3 className={clsx(classes.consumersHead)}>Help & Support</h3>
                <a
                style={{
                  marginTop:"24px"
                }}
                  href="#"
                  target="_blank"
                  className={clsx(classes.consumersText)}
                >
                  Raise a Request
                </a>
                <a
                  href="#"
                  target="_blank"
                  className={clsx(classes.consumersText)}
                >
                  My Orders
                </a>
                <a
                  href="#"
                  target="_blank"
                  className={clsx(classes.consumersText)}
                >
                  Track Order
                </a>
              </div> */}
            </div>

            <div
              className={clsx(
                classes.socialMediaContainer,
                classes.flex,
                classes.flexCol,
                classes.flex30,
                classes.spaceBw,
                classes.borderRight
              )}
            >
              {/* <div className={clsx(classes.socialMediaCard)}>
                              <div>
                                  <h5 className={clsx(classes.socialMediaHead)}>Follow us on</h5>
                                  <div className={clsx(classes.socialMediaIconCard, classes.flex)}>
                                      <div className={clsx(classes.socialMediaIcon,classes.flex, classes.justifyCenter)}>
                                        <a href="https://www.facebook.com/KheloMore/">
                                          <img  src={fbIcon} alt="icon" />
                                        </a>
                                      </div>
                                      <div className={clsx(classes.socialMediaIcon,classes.flex, classes.justifyCenter)}>
                                        <a href="https://www.instagram.com/khelomoreindia/">
                                          <img src={instaIcon} alt="icon" />
                                        </a>   
                                      </div>
                                      <div className={clsx(classes.socialMediaIcon,classes.flex, classes.justifyCenter)}>
                                        <a href="https://www.linkedin.com/company/khelomore/">
                                          <img src={lnkdinIcon} alt="icon" />
                                        </a>
                                      </div>
                                      <div className={clsx(classes.socialMediaIcon,classes.flex, classes.justifyCenter)}>
                                        <a href="https://twitter.com/KheloMore">
                                          <img className={classes.socialIcon} src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-homePageNew/xIcon.png" alt="icon" />
                                        </a>
                                      </div>
                                      <div className={clsx(classes.socialMediaIcon)}>
                                        <a href="https://open.spotify.com/show/2jdNwHmsjEQM7SjG2NDvFP?si=1abf50a9f37440c4">
                                          <img src={spotifyIcon} alt="icon" />
                                        </a>
                                      </div>
                                      <div className={clsx(classes.socialMediaIcon,classes.flex, classes.justifyCenter)}>
                                        <a href="https://www.youtube.com/channel/UC9SRqiqrQ1v9RoNX-Lnmqbg">
                                          <img src={youtubeIcon} alt="icon" />
                                        </a>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div className={clsx(classes.downloadBox)}>
                              <h5 className={clsx(classes.downloadText)}>Download the app</h5>
                              <div>
                                  <a href="https://apps.apple.com/in/app/khelomore-book-sports-venues/id1536558207"> <img className={clsx(classes.appleStoreFooter)} src={appleStore} alt="appleStore" /></a>
                                  <a href="https://play.google.com/store/apps/details?id=com.khelomore.pnp&hl=en_IN&gl=US"> <img src={googleStore} alt="googleStore" /> </a>
                              </div>
                          </div> */}
              <div className={clsx(classes.consumersCard)}>
                <h3 className={clsx(classes.consumersHead)}>Categories</h3>
                <a
                  href="https://shop.khelomore.com/collections/sport-equipments"
                  target="_blank"
                  className={clsx(classes.consumersText)}
                >
                  Sports Equipment
                </a>
                <a
                  href="https://shop.khelomore.com/collections/active-wear-and-shoes"
                  target="_blank"
                  className={clsx(classes.consumersText)}
                >
                  Active Wear & Shoes
                </a>
                <a
                  href="https://shop.khelomore.com/collections/acessories-and-essentials"
                  target="_blank"
                  className={clsx(classes.consumersText)}
                >
                  Accessories & Essentials
                </a>
              </div>
            </div>

            <div className={clsx(classes.flex, classes.flex30)}>
              <div className={clsx(classes.contactSection)}>
                <h6 className={clsx(classes.contactHead)}>Contact Us</h6>
                <div className={clsx(classes.contactText)}>
                  <p
                    className={clsx(
                      classes.contactPara,
                      classes.contactPadding
                    )}
                  >
                    2nd Floor, KHIL House, Nehru Road, Vile Parle (East),
                    <br></br>Adjoining Orchid Hotel, Mumbai, Maharashtra 400099{" "}
                  </p>
                  <div>
                    <span className={classes.contactNumber}>
                      +91 98 1989 0321
                    </span>
                    <span className={clsx(classes.contactPara)}>
                      info@khelomore.com
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr className={clsx(classes.hrFooter)}></hr>
        </div>
        <footer
          className={clsx(
            classes.copyright,
            classes.flex,
            classes.justifyCenter,
            classes.alignCenter
          )}
        >
          <small className={clsx(classes.copyrightText)}>
            © 2025 Khelomore Sports Private Limited. All Rights Reserved.
          </small>
        </footer>
      </div>
    </>
  );
}
